import { createPayloadAction } from "@dpdgroupuk/redux-action-creator";

import ActionTypes from "./actionTypes";

export const onInitAppState = data =>
  createPayloadAction(ActionTypes.FETCH_PREFERENCES.SUCCESS, data.auth);
